import { registerTranslation } from "@shoelace-style/localize";
import "./en.js";
const translation = {
  $code: "es",
  $name: "Español",
  $dir: "ltr",
  close: "Cerrar",
  loading: "Cargando",
  badInput: "No es un formato URL válido",
  typeMismatch: "No es un formato de correo electrónico válido",
  patternMismatch: "Que el formato coincida con el solicitado",
  rangeOverflow: (max, current) => `No uses más de ${max} caracteres (actualmente está usando ${current} caracteres)`,
  rangeUnderflow: (min, current) => `Usa al menos ${min} caracteres (actualmente está usando ${current} caracteres)`,
  valueMissing: "Completa este campo",
  dateRange: "La fecha debe estar dentro del rango correcto",
  alert_info: "Información Importante",
  alert_neutral: "Información Importante",
  alert_warning: "Alerta de Advertencia",
  alert_success: "Mensaje de Confirmacion",
  alert_error: "Mensaje de Error",
  back_to_top: "Volver",
  goodMorning: "¡Buenos días!",
  goodAfternoon: "¡Buenas tardes!",
  goodEvening: "¡Buenas noches!",
  search: "Buscar",
  searchPlaceholder: "Ingresa un término de búsqueda ",
  menu: "Menú",
  your_progress: "Su progreso",
  complete: "Completa",
  step: "Paso",
  of: "de",
  optional: "opcional",
  show: "Mostrar",
  hide: "Ocultar",
  // TODO: Move app translations to correct repo
  shop: "Comprar un plan",
  zip: "Ingresa tu código postal",
  forms_mode: "Activar el modo formularios para acceder el submenú",
  year: "año",
  years: "años",
  month: "mes",
  months: "meses",
  week: "semana",
  weeks: "semanas",
  day: "día",
  days: "días",
  hour: "hora",
  hours: "horas",
  minute: "minuto",
  minutes: "minutos",
  second: "segundo",
  seconds: "segundos",
  // CHC Date Picker
  sunday: "Domingo",
  monday: "Lunes",
  tuesday: "Martes",
  wednesday: "Miércoles",
  thursday: "Jueves",
  friday: "Viernes",
  saturday: "Sábado",
  sunday_short: "D",
  monday_short: "L",
  tuesday_short: "M",
  wednesday_short: "M",
  thursday_short: "J",
  friday_short: "V",
  saturday_short: "S",
  january: "Enero",
  february: "Febrero",
  march: "Marzo",
  april: "Abril",
  may: "Mayo",
  june: "Junio",
  july: "Julio",
  august: "Agosto",
  september: "Septiembre",
  october: "Octubre",
  november: "Noviembre",
  december: "Diciembre",
  january_short: "Ene",
  february_short: "Feb",
  march_short: "Mar",
  april_short: "Abr",
  may_short: "May",
  june_short: "Jun",
  july_short: "Jun",
  august_short: "Ago",
  september_short: "Sep",
  october_short: "Oct",
  november_short: "Nov",
  december_short: "Dic",
  instructions_one: "Puede navegar por día usando las flechas izquierda y derecha",
  instructions_two: "Semanas usando flechas hacia arriba y hacia abajo",
  instructions_three: "Meses usando las teclas de avance y retroceso de página",
  instructions_four: "Años usando shift plus page up y shift plus page down",
  instructions_five: "Las teclas de inicio y fin navegan hasta el principio y el final de una semana.",
  instructions_six: "Alternar calendario",
  navigate_back_year: "Navegar hacia atrás un año",
  navigate_back_month: "Navegar hacia atrás un mes",
  click_select_month: "Haga clic para seleccionar el mes",
  click_select_year: "Haga clic para seleccionar el año",
  navigate_forward_month: "Navegar hacia adelante un mes",
  navigate_forward_year: "Navegar hacia adelante un año",
  selected_date: "Fecha seleccionada",
  back: "Navegar hacia atrás",
  forward: "Navegar hacia adelante",
  showing_years: "Mostrando años",
  select_year: "Seleccione un año",
  select_month: "Selecciona un mes",
  to: "a"
};
registerTranslation(translation);
//# sourceMappingURL=es.js.map
